export default {
  props: ['newsModule'],
  data() {
    return {
      newslist: []
    };
  },
  mounted() {
    this.getNewsList();
  },
  methods: {
    handleMore() {
      window.location.href = `/news.html?module_name=${this.newsModule.module_name}&menu_id=${this.newsModule.menu_id}`;
    },
    async getNewsList() {
      const res = await this.$http.getNewsList({
        menu_id: this.newsModule.menu_id,
        keyWord: '',
        '_pageable.page': 0,
        '_pageable.size': 1
      });
      this.newslist = res.content;
    },
    handleDetail() {
      if (this.newslist[0].news_type == 1) {
        window.location.href = `/newsDetail.html?id=${this.newslist[0].id}&module_name=${this.newsModule.module_name}`;
      } else {
        window.open(this.newslist[0].news_url);
      }
    }
  }
};